
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getMailSenderGoogleSettingsDtoFormGroup() {
return new FormGroup({
    isConfigured: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    missingSettings: new FormControl<Array<string> | undefined>([], [Validators.required]),
    clientEmail: new FormControl<string | undefined>(undefined),
    clientId: new FormControl<string | undefined>(undefined),
    privateKeyConfigured: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    scopes: new FormControl<Array<string> | undefined>([], [Validators.required]),
})
;
}
      